import { inject, Injectable } from '@angular/core';
import { BannerService, ContactFormV3Service, SnackbarService } from '@gea/digital-ui-lib';
import {
  GlobalMessageService,
  GlobalMessageType,
  isTranslatable,
  Translatable,
  TranslationService,
} from '@spartacus/core';
import { of, take, withLatestFrom } from 'rxjs';

@Injectable()
export class CustomGlobalMessageService extends GlobalMessageService {
  geaMessageService = inject(BannerService);

  geaSnackbarService = inject(SnackbarService);

  translationService = inject(TranslationService);

  contactFormService = inject(ContactFormV3Service);

  override add(text: string | Translatable, type: GlobalMessageType, timeout?: number): void {
    let message$ = of(text);

    if (isTranslatable(text)) {
      if (text.key?.includes('badGateway')) {
        return;
      }
      message$ = this.translationService.translate(text.key as string);
    }
    message$
      .pipe(
        take(1),
        withLatestFrom(
          this.translationService.translate('common.success'),
          this.translationService.translate('common.reportError'),
        ),
      )
      .subscribe(([message, successMessage, reportLabel]) => {
        switch (type) {
          case GlobalMessageType.MSG_TYPE_ERROR:
            this.geaMessageService.add({
              severity: 'error',
              detail: message as string,
              life: timeout ?? 3000,
              data: {
                hasCloseButton: true,
                hasBannerButton: true,
                bannerButtonLabel: reportLabel,
                bannerButtonClicked: () => this.reportError(message as string),
              },
            });

            break;
          case GlobalMessageType.MSG_TYPE_WARNING:
            this.geaMessageService.add({
              severity: 'warn',
              detail: message as string,
              life: timeout ?? 3000,
              data: {
                hasCloseButton: true,
              },
            });

            break;
          case GlobalMessageType.MSG_TYPE_INFO:
            this.geaMessageService.add({
              severity: 'info',
              detail: message as string,
              life: timeout ?? 3000,
              data: {
                hasCloseButton: true,
              },
            });

            break;
          case GlobalMessageType.MSG_TYPE_CONFIRMATION:
            this.geaSnackbarService.add({
              detail: message as string,
              severity: 'success',
              summary: successMessage,
            });

            break;

          default:
            break;
        }
      });
  }

  reportError(message: string) {
    this.contactFormService.showContactForm();
    this.contactFormService.setContactFormDescription = message;
    this.contactFormService.setContactFormCategory = 'Report error';
  }
}
